<template>
    <!-- <img src="assets/img/download.jpg" class="w-full h-96"/> -->
    <h1 class="text-center text-black text-8xl text-bold"> More About Us </h1>
</template>
